import React, { useEffect, useState } from 'react'
import FlexView from 'react-flexview'
import { ActiveInsuranceModel } from '../../../../models/insurance-models/ActiveInsuranceModel'
import { PriceWithComma } from '../../../Core/PriceWithComma'
import './Modify.scss'
import NewButtonPopup from '../../../Core/Buttons/NewButtonPopup'
import { awaitWithLoading } from '../../../../services/utils'
import { ModificationContextStore } from '../../../../context/ModificationContext'
import { PolicyRenewalContextStore } from '../../../../context/PolicyRenewalContext'
import {
    Grid,
    Radio,
    FormControlLabel,
    Checkbox,
    RadioGroup,
} from '@material-ui/core'
import { SessionService } from '../../../../services/SessionService'
import { BrowserView, MobileView } from 'react-device-detect'
import { SkywatchDialog } from '../../../PopUps/SkywatchDialog'
import { ContinueButton } from '../../../Core/Buttons/ContinueButton'

interface PolicyAdditionalInsuredSectionProps {
    insurance: ActiveInsuranceModel;
}

export const CancelButton = ({ onClick, children, ...props }) => (
    <button
        className="midterm-cancel"
        onClick={() => onClick && onClick()}
        {...props}
    >
        {children}
    </button>
)
export const SubmitButton = ({ onClick, children, ...props }) => (
    <button
        className={
            props.disabled ? 'midterm-submit-disabled' : 'midterm-submit'
        }
        onClick={() => onClick && onClick()}
        {...props}
    >
        {children}
    </button>
)

export const ActionsSection = ({ insurance, isOpen, closeDialog, isRenewal, handleSubmit, getValues }: PolicyAdditionalInsuredSectionProps) => {
    const modificationContext = React.useContext(ModificationContextStore)
    const [disabled, setDisabled] = useState(false)
    const [withoutCC, setWithoutCC] = useState(false)
    const [error, setError] = useState('')
    const modificationObject = isRenewal
        ? modificationContext.subscription
        : modificationContext.insurance
    const [showPrice, setShowPrice] = useState(true)
    const [signPopUp, setSignPopUp] = useState(null)

    const paymentMethodChange = (event) => {
        setWithoutCC(!withoutCC)
    }
    const submitModify = async () => {
        await modificationContext.modify(isRenewal);
        closeDialog()
    }

    useEffect(() => {
        const validationList = [modificationContext.isCertificationValid]
        if(validationList.some(v => v === false )){
            setShowPrice(false)
            setDisabled(true)
            setError("Check for required fields/invalid data")
        }else{
            setShowPrice(true)
            setDisabled(false)
            setError("")
        }

    },[modificationContext.isCertificationValid])
    
    return (
        <Grid item xs={12} spacing={4}>
            <FlexView vAlignContent={'center'} hAlignContent="center">
                {!!error && <div className="text-body red">{error}</div>}
            </FlexView>
            <Grid container direction="column" className="actions-footer">
                <MobileView>
                    <Grid
                        className="price-subtitle margin-bottom-6"
                        container
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <div>
                            {isRenewal
                                ? 'Next renewal price:'
                                : 'Additional charge:'}
                        </div>
                        <PriceWithComma
                            price={
                                !!modificationObject && showPrice
                                    ? modificationObject.price
                                    : 0
                            }
                        />
                    </Grid>
                </MobileView>
                <Grid container justifyContent="space-between">
                    <CancelButton onClick={() => closeDialog()}>
                        Cancel
                    </CancelButton>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <BrowserView>
                            <div
                                className="price-subtitle"
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-end',
                                    marginRight: '1rem',
                                }}
                            >
                                <div className="bold">
                                    {isRenewal
                                        ? 'Next renewal price:'
                                        : 'Additional charge:'}
                                </div>
                                <PriceWithComma
                                    className="bolder"
                                    price={
                                        !!modificationObject && showPrice
                                            ? modificationObject.price
                                            : 0
                                    }
                                />
                            </div>
                        </BrowserView>
                        <SubmitButton
                            withFill={true}
                            disabled={!modificationObject.offer.offerId || disabled}
                            onClick={async () => {
                                submitModify()
                            }}
                        >
                            Save changes
                        </SubmitButton>
                    </div>
                </Grid>
            </Grid>
        </Grid>
    )
}
